// extracted by mini-css-extract-plugin
export default {"task":"task_task__oA+eI"};